import React from "react";
import { motion, Variants } from "framer-motion";
import { useTranslation } from "react-i18next"; // Импорт хука
import Section from "../components/Section";
import cls from "./StampsSection.module.css";

import stamp1 from '../assets/stamp2.png'
import stamp2 from '../assets/stamp1.png'

import marka1 from '../assets/marka1.png'
import marka2 from '../assets/marka2.png'
import marka3 from '../assets/marka3.png'

interface StampsSectionProps {
  isActive: boolean;
}

const titleVariants: Variants = {
  hidden: { opacity: 0, x: -40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3,
    },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, scale: 0.8, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { type: "spring", stiffness: 100, damping: 15 },
  },
};

const StampsSection: React.FC<StampsSectionProps> = ({ isActive }) => {
  const { t } = useTranslation();

  return (
    <Section isActive={isActive}>
      <div className={cls.aboutSection}>
        <div className={cls.container}>
          
          <motion.h2 
            className={cls.title}
            variants={titleVariants}
            initial="hidden"
            animate={isActive ? "visible" : "hidden"}
            dangerouslySetInnerHTML={{ __html: t('stamps.title') }} // Рендерим заголовок с <br/>
          />

          <motion.div 
            className={cls.stampsBlock}
            variants={containerVariants}
            initial="hidden"
            animate={isActive ? "visible" : "hidden"}
          >
            <div className={cls.stampsTop}>
              <motion.img variants={itemVariants} src={stamp1} alt="Stamp 1" />
              <motion.img variants={itemVariants} src={stamp2} alt="Stamp 2" />
            </div>

            <div className={cls.stampsBottom}>
              <motion.img variants={itemVariants} src={marka1} alt="Marka 1" />
              <motion.img variants={itemVariants} src={marka2} alt="Marka 2" />
              <motion.img variants={itemVariants} src={marka3} alt="Marka 3" />
            </div>
          </motion.div>

        </div>
      </div>
    </Section>
  );
};

export default StampsSection;